import { useGetMatchQuery } from '../../../services/objects';
import { modelIdFreeze } from './types'
import { Badge } from 'baseui/badge';
import { FormattedMessage } from 'react-intl';

const ActiveFreezeAlarms = (props: { parentId: string, parentResourceGroupId: string }) => {
    const { data: activeFreezeAlarms } = useGetMatchQuery({
        objectId: props.parentId,
        resourceGroupId: props.parentResourceGroupId,
        hops: '..3',
        relationship: 'Contains',
        modelId: modelIdFreeze,
        queryParameters: 'IsErr=true'
    });

    return (<>
        {activeFreezeAlarms && activeFreezeAlarms.length > 0 &&
            <Badge hierarchy='primary' color='negative' content={<FormattedMessage id="SensorDigitalAlarm.Antifreeze" defaultMessage="Antifreeze"></FormattedMessage>} />
        }
    </>)
}

export default ActiveFreezeAlarms;
